"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SiteReleaseUploadedItem}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseUploadedItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseUploadedItemConverter, _DataObjectConverter_);

  function SiteReleaseUploadedItemConverter() {
    _classCallCheck(this, SiteReleaseUploadedItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseUploadedItemConverter).apply(this, arguments));
  }

  return SiteReleaseUploadedItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseUploadedItemConverter = SiteReleaseUploadedItemConverter;